import { NavigationHierarchy } from "constants/routes/route-navigation-props";
import { NavigationCategories } from "types-for/routes";
import { getCurrentPage } from "utilities-for/routes/get-current-page";

/**
 * Determines if the navigation category passed is currently active.
 * @param navigationCategory The navigation category to check.
 * @param pathName Optional path name to check.
 * @returns boolean.
 */
export const isCurrentNavigationGroupActive = (
    navigationCategory: NavigationCategories,
    pathName: string = window.location.pathname
) => {
    const currentPage = getCurrentPage(pathName);
    const navigationItem = NavigationHierarchy[navigationCategory];
    if ("children" in navigationItem) {
        const isGroupActive = navigationItem.children.reduce((isActive, current) => {
            return isActive || current.pageName === currentPage;
        }, false);
        return isGroupActive;
    }
    return false;
};
